import { FacilityTypesFetchItem } from '../types';

export const FacilityTypes: FacilityTypesFetchItem[] = [
  {
    id: 'AmbulatoryCare',
    label: 'Ambulatory Care',
  },
  {
    id: 'AssistedLiving',
    label: 'Assisted Living',
  },
  {
    id: 'BehavioralHealthFacility',
    label: 'Behavioral Health Facility',
  },
  {
    id: 'Clinic',
    label: 'Clinic',
  },
  {
    id: 'ContinuingCareRetirementCommunities',
    label: 'Continuing Care Retirement Communities',
  },
  {
    id: 'HomeHealthAgency',
    label: 'Home Health Agency',
  },
  {
    id: 'Hospital',
    label: 'Hospital',
  },
  {
    id: 'Hospice',
    label: 'Hospice',
  },
  {
    id: 'LongTermAcuteCare',
    label: 'Long-Term Acute Care',
  },
  {
    id: 'LongTermCareFacility',
    label: 'Long-Term Care Facility',
  },
  {
    id: 'MemoryCare',
    label: 'Memory Care',
  },
  {
    id: 'OutpatientClinics',
    label: 'Outpatient Clinics',
  },
  {
    id: 'RehabilitationCenter',
    label: 'Rehabilitation Center',
  },
  {
    id: 'SkilledNursing',
    label: 'Skilled Nursing',
  },
  {
    id: 'UrgentCare ',
    label: 'Urgent Care Center',
  },
];
